// @flow

export const DEFAULT_PAGE_SIZE = 5
export const EMBEDDED_MENU_TYPE = 'embedded'
export const DROPDOWN_MENU_TYPE = 'dropdown'
export const DEFAULT_MIN_SEARCH_LENGTH = 3
